import React from 'react';
import './App.css';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Outlet } from "react-router-dom";
import hankoTheme from "./theme/HankoMaterialTheme";
import { SnackbarProvider } from "./components/Snackbar/SnackbarProvider";
import { HankoProvider } from "./components/HankoElements/HankoProvider";

function App() {
  return (
    <ThemeProvider theme={hankoTheme}>
      <HankoProvider>
        <SnackbarProvider>
          <CssBaseline />
          <Outlet />
        </SnackbarProvider>
      </HankoProvider>
    </ThemeProvider>
  );
}

export default App;
